import React from 'react';
import getResultIcon from './getResultIcon';

export default class RadioOptionListUI extends React.Component {
    renderRadioOption(option, i) {

        let optionId = String(option.id);
        let resultIcon = this.props.isTestResults ? getResultIcon(option.correct, this.props.value == option.id) : null;

        const inputField = (
            <input
                id={optionId}
                className="form-check-input"
                type="radio"
                defaultValue={optionId}
                defaultChecked={this.props.value == optionId}
                disabled={this.props.disabled}
                {...this.props.register(this.props.questionId)}
            />
        );

        return (
            <div key={i} data-answer-id={optionId}>
                {resultIcon}
                <div className="option-container form-check">
                    {inputField}
                    <label htmlFor={optionId} className="form-check-label">{option.text}</label>
                </div>
            </div>
        );
    }

    render() {
        let radioOptions = this.props.answerOptions.map(this.renderRadioOption.bind(this));

        return (
            <div className="row radio-option-list">
                <div className="col-12">
                    {radioOptions}
                </div>
            </div>
        );
    }
}
